import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../core/services/authentication.service';
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}
  uploaddocumentwithemail = false;
  queryUser = '';
  quryOppId = '';
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.authService.IsAuthenticated().then((auth: boolean) => {
      const currentUrlState = state.url;
      if (auth) {
        if (currentUrlState.includes('login')) {
          this.router.navigate(['/']);
        } else {
          return true;
        }
      } else {
        console.log(currentUrlState);
        if (currentUrlState.includes('user')) {
          this.router.navigate(['/debtapp']);
        } else if (currentUrlState.includes('life-insurance')) {
          this.router.navigate(['/life-insurance']);
        } else if (currentUrlState.includes('financial-planning')) {
          this.router.navigate(['/financial-planning']);
        } else if (currentUrlState.includes('superannuation')) {
          this.router.navigate(['/superannuation']);
        } else if (currentUrlState.includes('managed-account')) {
          this.router.navigate(['/managed-account']);
        } else if (currentUrlState.includes('general-insurance')) {
          this.router.navigate(['/general-insurance']);
        } else if (currentUrlState.includes('estate-planning')) {
          this.router.navigate(['/estate-planning']);
        } else if (currentUrlState.includes('health-insurance')) {
          this.router.navigate(['/health-insurance']);
        } else if (currentUrlState.includes('refinance-consolidation')) {
          this.router.navigate(['/debtapp']);
        } else if (currentUrlState.includes('financial-goal')) {
          this.router.navigate(['/debtapp']);
        } else if (currentUrlState.includes('login')) {
          return true;
        } else {
          this.router.navigate(['/']);
        }
      }
    });
  }
}
